import { render, staticRenderFns } from "./AttractivityTab.vue?vue&type=template&id=6e7b2ef5&"
import script from "./AttractivityTab.vue?vue&type=script&lang=js&"
export * from "./AttractivityTab.vue?vue&type=script&lang=js&"
import style0 from "./AttractivityTab.vue?vue&type=style&index=0&id=6e7b2ef5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports